<template>
  <router-view/>
</template>

<script>
export default {
  name: 'Teacher',
  data: () => ({
  }),
  mounted() {
  },
  methods: {
  },
};
</script>

<style>

</style>
